import { Controller } from "@hotwired/stimulus"

// Verbindet stimulus controller für verschachtelte Formulare
export default class extends Controller {
    static targets = ["template", "container"]
    static values = {
        wrapperSelector: String,
        nextIndex: Number
    }

    connect() {
        this.wrapperSelector ||= ".nested-fields"
        this.nextIndexValue ||= 0
    }

    add(event) {
        event.preventDefault()

        const templateContent = this.templateTarget.innerHTML.replace(
            /NEW_RECORD/g,
            new Date().getTime()
        )

        this.containerTarget.insertAdjacentHTML("beforeend", templateContent)
        this.nextIndexValue++
    }

    remove(event) {
        event.preventDefault()

        const wrapper = event.target.closest(this.wrapperSelectorValue || this.wrapperSelector)

        if (wrapper) {
            // Wenn ein verstecktes _destroy Feld existiert, setze es auf true
            const destroyField = wrapper.querySelector("input[name*='[_destroy]']")

            if (destroyField) {
                destroyField.value = true
                wrapper.style.display = "none"
            } else {
                wrapper.remove()
            }
        }
    }
}
